import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Method } from './components/Method';
import { BooksIncluded } from './components/BooksIncluded';
import { Bonus } from './components/Bonus';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { AboutNicole } from './components/AboutNicole';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { motion } from 'framer-motion';
const SparkDivider = () => <motion.div initial={{
  opacity: 0
}} whileInView={{
  opacity: 1
}} viewport={{
  once: true
}} transition={{
  duration: 1
}} className="flex justify-center items-center space-x-4 py-8 text-rosegold/60" data-id="element-0">
    <motion.div animate={{
    rotate: 360
  }} transition={{
    duration: 10,
    repeat: Infinity,
    ease: 'linear'
  }} className="w-6 h-6 drop-shadow-[0_0_4px_rgba(212,132,154,0.5)]" data-id="element-1">
      <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-2">
        <defs data-id="element-3">
          <linearGradient id="sparkDiamond1" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-4">
            <stop offset="0%" stopColor="#F5E0E8" data-id="element-5" />
            <stop offset="50%" stopColor="#D4849A" data-id="element-6" />
            <stop offset="100%" stopColor="#A06080" data-id="element-7" />
          </linearGradient>
        </defs>
        <polygon points="50,5 90,35 75,90 25,90 10,35" fill="url(#sparkDiamond1)" stroke="#D4849A" strokeWidth="1.5" data-id="element-8" />
        <polygon points="50,5 90,35 50,35" fill="#FFF5F8" fillOpacity="0.5" data-id="element-9" />
        <polygon points="50,35 75,90 25,90" fill="#FFF5F8" fillOpacity="0.3" data-id="element-10" />
        <polygon points="50,5 55,20 50,35 45,20" fill="white" fillOpacity="0.7" data-id="element-11" />
      </svg>
    </motion.div>
    <motion.span animate={{
    scale: [1, 1.5, 1],
    opacity: [0.5, 1, 0.5]
  }} transition={{
    duration: 2,
    repeat: Infinity
  }} data-id="element-12">
      ✦
    </motion.span>
    <motion.div animate={{
    rotate: -360
  }} transition={{
    duration: 10,
    repeat: Infinity,
    ease: 'linear'
  }} className="w-6 h-6 drop-shadow-[0_0_4px_rgba(212,132,154,0.5)]" data-id="element-13">
      <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-14">
        <polygon points="50,5 90,35 75,90 25,90 10,35" fill="url(#sparkDiamond1)" stroke="#D4849A" strokeWidth="1.5" data-id="element-15" />
        <polygon points="50,5 90,35 50,35" fill="#FFF5F8" fillOpacity="0.5" data-id="element-16" />
        <polygon points="50,35 75,90 25,90" fill="#FFF5F8" fillOpacity="0.3" data-id="element-17" />
        <polygon points="50,5 55,20 50,35 45,20" fill="white" fillOpacity="0.7" data-id="element-18" />
      </svg>
    </motion.div>
  </motion.div>;
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-taupe selection:bg-rosegold/30 selection:text-burgundy" data-id="element-19">
      <Navbar data-id="element-20" />
      <main data-id="element-21">
        <Hero data-id="element-22" />
        <SparkDivider data-id="element-23" />
        <PainPoints data-id="element-24" />
        <SparkDivider data-id="element-25" />
        <Method data-id="element-26" />
        <SparkDivider data-id="element-27" />
        <BooksIncluded data-id="element-28" />
        <SparkDivider data-id="element-29" />
        <Bonus data-id="element-30" />
        <SparkDivider data-id="element-31" />
        <Testimonials data-id="element-32" />
        <SparkDivider data-id="element-33" />
        <Pricing data-id="element-34" />
        <SparkDivider data-id="element-35" />
        <FAQ data-id="element-36" />
        <SparkDivider data-id="element-37" />
        <AboutNicole data-id="element-38" />
        <FinalCTA data-id="element-39" />
      </main>
      <Footer data-id="element-40" />
    </div>;
}